// extracted by mini-css-extract-plugin
export var arrow = "_c8-2";
export var label = "_c8-1";
export var reminder = "_c8-0";